import { useState } from "react";
import { Button } from "react-bootstrap";
import { Input } from "../Controls/Input";
import { ReportsApi } from "../shared/api/axios-client";
import { createApiService } from "../shared/apiConfig";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

export default function RecurringReportDownloadPage() {
  const urlParams = new URLSearchParams(window.location.search);
  const scheduleId = urlParams.get("id");
  const { facilityId } = useParams();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const reportsApi = createApiService(ReportsApi);
  const nav = useNavigate();

  // Email validation function
  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle email input change with validation
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    
    if (value && !validateEmail(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleDownload = async () => {
    setLoading(true);

    try {
      const result =
        await reportsApi.monitorReportsRecurringReportsDownloadLinkGet({
          id: scheduleId!,
          email: email,
        });

      if (result.status !== 200) {
        setLoading(false);
        return;
      }

      const downloadUrl = result.data;

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `ScheduledReport.xlsx`;
      link.click();
      toast.success("Download completed");
    } catch (err: any) {
      if (err.response?.status === 403) {
        toast.error("You do not have access to this report");
      } else {
        toast.error("Something went wrong. Please try again");
      }
    } finally {
      setLoading(false);
    }
  };

  if (!scheduleId) {
    return (
      <div className="max-w-md mx-auto mt-20 p-4 bg-white shadow rounded">
        <h1 className="text-xl font-semibold mb-4 text-red-600">
          Invalid Download Link
        </h1>
        <p>
          Please check the link you received in the email. The report cannot be
          accessed.
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-md w-70 mx-auto mt-20 p-4 bg-white shadow rounded">
    
      <h1 className="text-xl font-semibold mb-4">Download Your Report</h1>
      <p className="mb-0 text-sm text-gray-600">
        Enter your email to verify access:
      </p>

      <Input
        label=""
        type="email"
        placeholder="your@email.com"
        value={email}
        onChange={handleEmailChange}
        disabled={loading}
        autoFocus={true}
      />
      {emailError && (
        <div className="text-red-500 text-sm mt-1">{emailError}</div>
      )}

      <Button
        onClick={handleDownload}
        className="mt-4 w-full"
        disabled={!email || emailError !== "" || loading}
      >
        {loading ? "Checking & Downloading..." : "Download Report"}
      </Button>
    </div>
  );
}
